import ProductCard from "components/ProductCard";
import type { Product } from "data/products";
// type RelatedProductsProps = {
//   relatedProductSlugs: Product[];
// };

export default function RelatedProducts({
  relatedProducts,
}: {
  relatedProducts: Product[];
}) {
  return (
    <>
      <h2>Découvrez le reste de notre gamme</h2>
      <div className="grid" style={{ marginTop: 12 }}>
        {relatedProducts.map((product: Product) => (
          <ProductCard key={product.sku} productSpecific={product} />
        ))}
      </div>
    </>
  );
}
